export enum IconName {
	AlignRows = "align-rows",
	Archive = "archive",
	ArrowLeft = "arrow-left",
	ArrowUpRight = "arrow-up-right",
	ArrowsSwap = "arrows-swap",
	ArrowsSwapCompact = "arrows-swap-compact",
	Bell = "bell",
	BarChart = "bar-chart",
	Bookmark = "bookmark",
	Calendar = "calendar",
	Check = "check",
	CheckSmall = "check-small",
	ChevronDown = "chevron-down",
	ChevronDownSmall = "chevron-down-small",
	ChevronLeft = "chevron-left",
	ChevronRight = "chevron-right",
	ChevronRightSmall = "chevron-right-small",
	ChevronsCollapse = "chevrons-collapse",
	ChevronsExpand = "chevrons-expand",
	CircleAlert = "circle-alert",
	Close = "close",
	CloseSmall = "close-small",
	Compass = "compass",
	CompassNeedle = "compass-needle",
	Copy = "copy",
	CopySmall = "copy-small",
	Crosshair = "crosshair",
	Download = "download",
	ExternalLink = "external-link",
	EyeOff = "eye-off",
	FileLines = "file-lines",
	FileText = "file-text",
	Filter = "filter",
	Flag = "flag",
	Folder = "folder",
	FolderWide = "folder-wide",
	Google = "google",
	GoogleMaps = "google-maps",
	Grid = "grid",
	Heart = "heart",
	Hexagons = "hexagons",
	Hubspot = "hubspot",
	HubspotColor = "hubspot-color",
	IdCard = "id-card",
	Info = "info",
	Layers = "layers",
	LineSegment = "line-segment",
	LinkedIn = "linkedin",
	LinkChain = "link-chain",
	Locate = "locate",
	LogIn = "log-in",
	LogOut = "log-out",
	Mail = "mail",
	MailSmall = "mail-small",
	MapPin = "map-pin",
	MapPinSmall = "map-pin-small",
	Menu = "menu",
	Microsoft = "microsoft",
	PanelLeftCollapse = "panel-left-collapse",
	PanelRightCollapse = "panel-right-collapse",
	PanelRightOpen = "panel-right-open",
	Paperclip = "paperclip",
	Pencil = "pencil",
	Pentagon = "pentagon",
	PencilBox = "pencil-box",
	PencilEdit = "pencil-edit",
	Phone = "phone",
	Send = "send",
	Settings = "settings",
	ShieldPin = "shield-pin",
	Smartphone = "smartphone",
	Plus = "plus",
	Ruler = "ruler",
	Run = "run",
	Search = "search",
	Tag = "tag",
	Settings2 = "settings-2",
	Table = "table",
	TableList = "table-list",
	Target = "target",
	Trash = "trash",
	TrashSmall = "trash-small",
	User = "user",
	UserCircle = "user-circle",
	UserDollar = "user-dollar",
	UserSearch = "user-search",
}

type IconDefinition = {
	viewBox?: string
	body: string
	raw?: boolean
}

const DEFAULT_VIEW_BOX = "0 0 24 24"

const definitions: Record<IconName, IconDefinition> = {
	[IconName.AlignRows]: {
		body: `<path d="M4 4h16M6 8h12M8 12h8M10 16h4" />`,
	},
	[IconName.Archive]: {
		body: `<path d="M11 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12 7H19C20.1046 7 21 7.89543 21 9V10" /><rect x="14" y="15" width="7" height="5" rx="1" /><path d="M16 13.5C16 12.6716 16.6716 12 17.5 12V12C18.3284 12 19 12.6716 19 13.5V15H16V13.5Z" />`,
	},
	[IconName.ArrowLeft]: {
		body: `<path d="M19 12H5M12 19l-7-7 7-7" />`,
	},
	[IconName.ArrowUpRight]: {
		body: `<path d="M7 17L17 7M17 7H9M17 7V15" />`,
	},
	[IconName.ArrowsSwap]: {
		body: `<path d="M6 3L2 7l4 4" /><path d="M2 7h14a4 4 0 0 1 4 4v2" /><path d="M18 21l4-4-4-4" /><path d="M22 17H8a4 4 0 0 1-4-4v-2" />`,
	},
	[IconName.ArrowsSwapCompact]: {
		viewBox: "0 0 16 16",
		body: `<path d="M2 5h9M11 5L8 2M11 5L8 8M14 11H5M5 11l3 3M5 11l3-3" />`,
	},
	[IconName.Bell]: {
		body: `<path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9z" /><path d="M13.73 21a2 2 0 0 1-3.46 0" />`,
	},
	[IconName.BarChart]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><rect x="7" y="13" width="2" height="5" fill="currentColor" stroke="none" /><rect x="11" y="10" width="2" height="8" fill="currentColor" stroke="none" /><rect x="15" y="7" width="2" height="11" fill="currentColor" stroke="none" />`,
	},
	[IconName.Bookmark]: {
		raw: true,
		body: `<path d="M6 4a2 2 0 0 0-2 2v14l8-5 8 5V6a2 2 0 0 0-2-2H6z" />`,
	},
	[IconName.Calendar]: {
		body: `<rect x="3.5" y="4.5" width="17" height="16" rx="2" /><path d="M3.5 9.5H20.5" /><path d="M8 2.5V6.5" /><path d="M16 2.5V6.5" />`,
	},
	[IconName.Check]: {
		body: `<path d="M4 12l5 5L20 6" />`,
	},
	[IconName.CheckSmall]: {
		viewBox: "0 0 12 9",
		body: `<path d="M1 4l3.5 3.5L11 1" />`,
	},
	[IconName.ChevronDown]: {
		body: `<path d="M6 9l6 6 6-6" />`,
	},
	[IconName.ChevronDownSmall]: {
		viewBox: "0 0 10 6",
		body: `<path d="M1 1l4 4 4-4" />`,
	},
	[IconName.ChevronLeft]: {
		body: `<path d="M15 6l-6 6 6 6" />`,
	},
	[IconName.ChevronRight]: {
		body: `<path d="M9 6l6 6-6 6" />`,
	},
	[IconName.ChevronRightSmall]: {
		viewBox: "0 0 14 14",
		body: `<path d="M5 3l4 4-4 4" />`,
	},
	[IconName.ChevronsCollapse]: {
		viewBox: "0 0 18 18",
		body: `<path d="M9.5 4.5L5 9L9.5 13.5M15.5 4.5L11 9L15.5 13.5" />`,
	},
	[IconName.ChevronsExpand]: {
		viewBox: "0 0 18 18",
		body: `<path d="M8.5 4.5L13 9L8.5 13.5M2.5 4.5L7 9L2.5 13.5" />`,
	},
	[IconName.Close]: {
		body: `<path d="M18 6L6 18M6 6l12 12" />`,
	},
	[IconName.CloseSmall]: {
		viewBox: "0 0 16 16",
		body: `<path d="M3 3l10 10M13 3L3 13" />`,
	},
	[IconName.Compass]: {
		body: `<circle cx="12" cy="12" r="9.75" /><path d="M16.2 7.8 13.8 13.8 7.8 16.2 10.2 10.2z" /><path d="M16.2 7.8 14 13.2 10.8 10z" fill="currentColor" />`,
	},
	[IconName.CompassNeedle]: {
		body: `<path d="M12 2.5 8 12h8z" fill="currentColor" /><path d="M8 12h8l-4 9.5z" />`,
	},
	[IconName.Copy]: {
		body: `<rect x="8" y="8" width="10" height="10" rx="2" /><path d="M6 14H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v1" />`,
	},
	[IconName.CopySmall]: {
		viewBox: "0 0 16 16",
		body: `<rect x="5.5" y="5.5" width="8" height="8" rx="1.5" /><path d="M2.5 10.5v-7A1.5 1.5 0 0 1 4 2h7" />`,
	},
	[IconName.Crosshair]: {
		body: `<circle cx="12" cy="12" r="9" /><path d="M12 2v4M12 18v4M2 12h4M18 12h4" />`,
	},
	[IconName.Download]: {
		body: `<path d="M12 3v11m0 0 4-4m-4 4-4-4M5 20h14" />`,
	},
	[IconName.ExternalLink]: {
		body: `<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><path d="M15 3h6v6" /><path d="M10 14L21 3" />`,
	},
	[IconName.EyeOff]: {
		body: `<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24" /><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" /><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" /><path d="M2 2l20 20" />`,
	},
	[IconName.FileLines]: {
		body: `<path d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z" />`,
	},
	[IconName.FileText]: {
		body: `<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" /><path d="M14 2v6h6" /><path d="M16 13H8M16 17H8M10 9H8" />`,
	},
	[IconName.Filter]: {
		body: `<path d="M4 5h16l-6 8v6l-4-2v-4z" />`,
	},
	[IconName.Flag]: {
		body: `<path d="M5 21V4" /><path d="M5 4h13l-3 4 3 4H5" />`,
	},
	[IconName.Folder]: {
		body: `<path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7Z" />`,
	},
	[IconName.FolderWide]: {
		body: `<path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" />`,
	},
	[IconName.Google]: {
		raw: true,
		body: `<path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" /><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" /><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" /><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />`,
	},
	[IconName.GoogleMaps]: {
		raw: true,
		viewBox: "0 0 232597 333333",
		body: `<path d="M151444 5419C140355 1916 128560 0 116311 0 80573 0 48591 16155 27269 41534l54942 46222 69232-82338z" fill="#1a73e8" /><path d="M27244 41534C10257 61747 0 87832 0 116286c0 21876 4360 39594 11517 55472l70669-84002-54942-46222z" fill="#ea4335" /><path d="M116311 71828c24573 0 44483 19910 44483 44483 0 10938-3957 20969-10509 28706 0 0 35133-41786 69232-82313-14089-27093-38510-47936-68048-57286L82186 87756c8166-9753 20415-15928 34125-15928z" fill="#4285f4" /><path d="M116311 160769c-24573 0-44483-19910-44483-44483 0-10863 3906-20818 10358-28555l-70669 84027c12072 26791 32159 48289 52851 75381l85891-102122c-8141 9628-20339 15752-33948 15752z" fill="#fbbc04" /><path d="M148571 275014c38787-60663 84026-88210 84026-158728 0-19331-4738-37552-13080-53581L64393 247140c6578 8620 13206 17793 19683 27900 23590 36444 17037 58294 32260 58294 15172 0 8644-21876 32235-58320z" fill="#34a853" />`,
	},
	[IconName.Grid]: {
		body: `<rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" />`,
	},
	[IconName.Heart]: {
		raw: true,
		viewBox: "0 0 471.701 471.701",
		body: `<path class="ico-heart-outline" fill-rule="evenodd" stroke="currentColor" stroke-width="0.5" stroke-linejoin="round" vector-effect="non-scaling-stroke" d="M433.601 67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7 13.6-92.4 38.3l-12.9 12.9-13.1-13.1c-24.7-24.7-57.6-38.4-92.5-38.4-34.8 0-67.6 13.6-92.2 38.2-24.7 24.7-38.3 57.5-38.2 92.4 0 34.9 13.7 67.6 38.4 92.3l187.8 187.8c2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-3.9l188.2-187.5c24.7-24.7 38.3-57.5 38.3-92.4 0-34.9-13.5-67.7-38.2-92.4zM414.401 232.701l-178.7 178-178.3-178.3c-19.6-19.6-30.4-45.6-30.4-73.3s10.7-53.7 30.3-73.2c19.5-19.5 45.5-30.3 73.1-30.3 27.7 0 53.8 10.8 73.4 30.4l22.6 22.6c5.3 5.3 13.8 5.3 19.1 0l22.4-22.4c19.6-19.6 45.7-30.4 73.3-30.4 27.6 0 53.6 10.8 73.2 30.3 19.6 19.6 30.3 45.6 30.3 73.3 0 27.7-10.8 53.7-30.4 73.3z" /><path class="ico-heart-fill" d="M433.601 67.001c-24.7-24.7-57.4-38.2-92.3-38.2s-67.7 13.6-92.4 38.3l-12.9 12.9-13.1-13.1c-24.7-24.7-57.6-38.4-92.5-38.4-34.8 0-67.6 13.6-92.2 38.2-24.7 24.7-38.3 57.5-38.2 92.4 0 34.9 13.7 67.6 38.4 92.3l187.8 187.8c2.6 2.6 6.1 4 9.5 4 3.4 0 6.9-1.3 9.5-3.9l188.2-187.5c24.7-24.7 38.3-57.5 38.3-92.4 0-34.9-13.5-67.7-38.2-92.4z" />`,
	},
	[IconName.Hexagons]: {
		body: `<path d="M12 2 2 7l10 5 10-5-10-5z" /><path d="m2 12 10 5 10-5" /><path d="m2 17 10 5 10-5" />`,
	},
	[IconName.Hubspot]: {
		raw: true,
		body: `<path fill="currentColor" d="M18.164 7.931V5.085a2.198 2.198 0 0 0 1.266-1.978V3.04A2.199 2.199 0 0 0 17.238.847h-.067a2.199 2.199 0 0 0-2.193 2.192v.067a2.196 2.196 0 0 0 1.252 1.973l.013.006v2.852a6.22 6.22 0 0 0-2.969 1.31l.012-.009-7.828-6.096a2.497 2.497 0 1 0-1.157 1.515l-.012.006 7.696 5.991a6.176 6.176 0 0 0-1.038 3.446c0 1.343.425 2.588 1.147 3.606l-.013-.019-2.342 2.342a1.968 1.968 0 0 0-.58-.095h-.002a2.033 2.033 0 1 0 2.033 2.033 1.978 1.978 0 0 0-.099-.595l.004.014 2.317-2.317a6.247 6.247 0 1 0 4.782-11.133l-.036-.005zm-.964 9.377a3.206 3.206 0 1 1 3.214-3.206v.002a3.206 3.206 0 0 1-3.206 3.206z" />`,
	},
	[IconName.HubspotColor]: {
		raw: true,
		viewBox: "6.20856283 .64498824 244.26943717 251.24701176",
		body: `<path fill="#ff7a59" d="m191.385 85.694v-29.506a22.722 22.722 0 0 0 13.101-20.48v-.677c0-12.549-10.173-22.722-22.721-22.722h-.678c-12.549 0-22.722 10.173-22.722 22.722v.677a22.722 22.722 0 0 0 13.101 20.48v29.506a64.342 64.342 0 0 0 -30.594 13.47l-80.922-63.03c.577-2.083.878-4.225.912-6.375a25.6 25.6 0 1 0 -25.633 25.55 25.323 25.323 0 0 0 12.607-3.43l79.685 62.007c-14.65 22.131-14.258 50.974.987 72.7l-24.236 24.243c-1.96-.626-4-.959-6.057-.987-11.607.01-21.01 9.423-21.007 21.03.003 11.606 9.412 21.014 21.018 21.017 11.607.003 21.02-9.4 21.03-21.007a20.747 20.747 0 0 0 -.988-6.056l23.976-23.985c21.423 16.492 50.846 17.913 73.759 3.562 22.912-14.352 34.475-41.446 28.985-67.918-5.49-26.473-26.873-46.734-53.603-50.792m-9.938 97.044a33.17 33.17 0 1 1 0-66.316c17.85.625 32 15.272 32.01 33.134.008 17.86-14.127 32.522-31.977 33.165" />`,
	},
	[IconName.IdCard]: {
		body: `<rect x="3" y="4" width="18" height="14" rx="2" /><path d="M3 9h18" /><path d="M8 13h8" />`,
	},
	[IconName.Info]: {
		body: `<circle cx="12" cy="12" r="9" /><path d="M12 11v5.5" /><circle cx="12" cy="7.75" r="1" fill="currentColor" stroke="none" />`,
	},
	[IconName.CircleAlert]: {
		body: `<circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5" /><circle cx="12" cy="16.25" r="1" fill="currentColor" stroke="none" />`,
	},
	[IconName.Layers]: {
		body: `<path d="M3 6l6-3 6 3 6-3v12l-6 3-6-3-6 3V6z" /><path d="M9 3v12M15 6v12" />`,
	},
	[IconName.LineSegment]: {
		body: `<path d="m7.8 16.2 8.4-8.4" /><circle cx="5.5" cy="18.5" r="2.3" fill="currentColor" /><circle cx="18.5" cy="5.5" r="2.3" fill="currentColor" />`,
	},
	[IconName.LinkedIn]: {
		raw: true,
		body: `<path fill="#0077B5" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />`,
	},
	[IconName.LinkChain]: {
		body: `<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />`,
	},
	[IconName.Locate]: {
		body: `<circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" /><path d="M12 1v4M12 19v4M1 12h4M19 12h4" />`,
	},
	[IconName.LogIn]: {
		body: `<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><path d="M10 17l5-5-5-5" /><path d="M15 12H3" />`,
	},
	[IconName.LogOut]: {
		body: `<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" />`,
	},
	[IconName.Mail]: {
		body: `<path d="M4 6h16v12H4V6z" /><path d="m4 7 8 6 8-6" />`,
	},
	[IconName.MailSmall]: {
		viewBox: "0 0 16 16",
		body: `<rect x="1.5" y="3" width="13" height="10" rx="1.5" /><path d="M2 4l6 5 6-5" />`,
	},
	[IconName.MapPin]: {
		body: `<path d="M12 21s-7-7.373-7-12a7 7 0 1 1 14 0c0 4.627-7 12-7 12z" /><circle cx="12" cy="9" r="2.5" />`,
	},
	[IconName.MapPinSmall]: {
		viewBox: "0 0 20 20",
		body: `<path d="M10 18s6-5.686 6-10a6 6 0 1 0-12 0c0 4.314 6 10 6 10Z" /><circle cx="10" cy="8" r="2" />`,
	},
	[IconName.Menu]: {
		viewBox: "0 0 18 18",
		body: `<path d="M3.5 5.5h11M3.5 9.5h11M3.5 13.5h11" />`,
	},
	[IconName.Microsoft]: {
		raw: true,
		body: `<path d="M0 0h11v11H0V0z" fill="#F25022" /><path d="M12 0h11v11H12V0z" fill="#7FBA00" /><path d="M0 12h11v11H0V12z" fill="#00A4EF" /><path d="M12 12h11v11H12V12z" fill="#FFB900" />`,
	},
	[IconName.PanelLeftCollapse]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M9 3v18" /><path d="m16 15-3-3 3-3" />`,
	},
	[IconName.PanelRightCollapse]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M15 3v18" /><path d="m8 9 3 3-3 3" />`,
	},
	[IconName.PanelRightOpen]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M15 3v18" /><path d="m10 15-3-3 3-3" />`,
	},
	[IconName.Paperclip]: {
		viewBox: "0 0 16 16",
		body: `<path d="M6.5 9.5 12 4M9.5 4H12v2.5" /><path d="M7 4H4.5A1.5 1.5 0 0 0 3 5.5v6A1.5 1.5 0 0 0 4.5 13h6A1.5 1.5 0 0 0 12 11.5V9" />`,
	},
	[IconName.Pencil]: {
		body: `<path d="M12 20h9M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5Z" />`,
	},
	[IconName.PencilEdit]: {
		body: `<path d="M4 20h4l10.5-10.5a2.8 2.8 0 0 0-4-4L4 16v4z" /><path d="M13.5 6.5l4 4" />`,
	},
	[IconName.Pentagon]: {
		body: `<path d="M12 3.5 20.5 9.7 17.2 19.5H6.8L3.5 9.7 12 3.5Z" />`,
	},
	[IconName.PencilBox]: {
		viewBox: "0 0 21 21",
		body: `<g transform="translate(3 3)"><path d="m7 1.5h-4.5c-1.1045695 0-2 .8954305-2 2v9.0003682c0 1.1045695.8954305 2 2 2h10c1.1045695 0 2-.8954305 2-2v-4.5003682" /><path d="m14.5.46667982c.5549155.5734054.5474396 1.48588056-.0167966 2.05011677l-6.9832034 6.98320341-3 1 1-3 6.9874295-7.04563515c.5136195-.5178979 1.3296676-.55351813 1.8848509-.1045243z" /><path d="m12.5 2.5.953 1" /></g>`,
	},
	[IconName.Phone]: {
		viewBox: "0 0 16 16",
		body: `<path d="M3 2.5h2.2l1 3-1.4 1.2a8 8 0 0 0 4.5 4.5l1.2-1.4 3 1v2.2c0 .6-.5 1-1 1A11 11 0 0 1 2 3.5c0-.5.4-1 1-1z" />`,
	},
	[IconName.Send]: {
		viewBox: "0 0 16 16",
		body: `<path d="M2 8.5 13.5 2.5 9.5 13.5 7.5 9 2 8.5Z" /><path d="M7.5 9 11 5.5" />`,
	},
	[IconName.Settings]: {
		body: `<circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />`,
	},
	[IconName.ShieldPin]: {
		body: `<path d="M12 2L4 5v6.09c0 5.03 3.48 9.74 8 10.91 4.52-1.17 8-5.88 8-10.91V5l-8-3z" /><circle cx="12" cy="11" r="2" /><path d="M12 13v4" />`,
	},
	[IconName.Smartphone]: {
		body: `<rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" />`,
	},
	[IconName.Plus]: {
		body: `<path d="M12 8v8M8 12h8" />`,
	},
	[IconName.Ruler]: {
		body: `<path d="M2.8 15.2 15.2 2.8 21.2 8.8 8.8 21.2z" /><path d="m6.5 11.5 2.8 2.8M9 9l2.8 2.8M11.5 6.5l2.8 2.8" />`,
	},
	[IconName.Run]: {
		body: `<path d="M3 5h12M9 3v2m1.5 0c-.8 3.9-3.2 7.2-6.5 9.5" /><path d="M5.5 8.5c1 2.2 2.8 4 5 5.2M14 21l4-9 4 9m-6.8-3h5.6" />`,
	},
	[IconName.Search]: {
		body: `<circle cx="11" cy="11" r="7" /><path d="m16 16 5 5" />`,
	},
	[IconName.Tag]: {
		body: `<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />`,
	},
	[IconName.Settings2]: {
		body: `<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z" /><circle cx="12" cy="12" r="3" />`,
	},
	[IconName.Table]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M3 15h18M9 3v18M15 3v18" />`,
	},
	[IconName.TableList]: {
		body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M3 9h18M3 15h18M9 3v18" />`,
	},
	[IconName.Target]: {
		body: `<circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />`,
	},
	[IconName.Trash]: {
		body: `<path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v5M14 11v5" />`,
	},
	[IconName.TrashSmall]: {
		viewBox: "0 0 16 16",
		body: `<path d="M2.5 4.5h11M6 4.5V3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M12.5 4.5l-.6 8.4a1 1 0 0 1-1 .93H5.1a1 1 0 0 1-1-.93l-.6-8.4M6.5 7.5v4M9.5 7.5v4" />`,
	},
	[IconName.User]: {
		body: `<circle cx="12" cy="8" r="4" /><path d="M4 21c0-4.418 3.582-8 8-8s8 3.582 8 8" />`,
	},
	[IconName.UserCircle]: {
		body: `<circle cx="12" cy="10" r="3" /><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z" /><path d="M5.235 19.385A9.965 9.965 0 0 1 12 17c2.57 0 4.91.972 6.765 2.385" />`,
	},
	[IconName.UserDollar]: {
		body: `<circle cx="8" cy="6" r="3.5" /><path d="M1 20.5c0-3.866 3.134-7 7-7s7 3.134 7 7" /><g transform="translate(12.5, 0) scale(0.6)"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke-width="2.5" /></g>`,
	},
	[IconName.UserSearch]: {
		body: `<circle cx="10" cy="10" r="7.5" /><path d="M20.5 20.5 16 16" /><circle cx="10" cy="7.6" r="2.4" fill="currentColor" stroke="none" /><path d="M5.6 14.2C5.6 11.9 7.6 10.6 10 10.6C12.4 10.6 14.4 11.9 14.4 14.2C14.4 16 13.2 17.4 10 17.4C6.8 17.4 5.6 16 5.6 14.2Z" fill="currentColor" stroke="none" />`,
	},
}

const FALLBACK: IconDefinition = {
	body: `<rect x="3" y="3" width="18" height="18" rx="2" /><path d="M8 12h8" />`,
}

const warned = new Set<string>()

function resolveDefinition(name: IconName): IconDefinition {
	const definition = definitions[name]
	if (definition) return definition
	if (!warned.has(name)) {
		warned.add(name)
		console.warn(`[AppIcon] no icon registered for "${name}", using fallback`)
	}
	return FALLBACK
}

export function iconViewBox(name: IconName): string {
	return resolveDefinition(name).viewBox ?? DEFAULT_VIEW_BOX
}

export function iconBody(name: IconName): string {
	return resolveDefinition(name).body
}

export function iconIsRaw(name: IconName): boolean {
	return resolveDefinition(name).raw ?? false
}

export function allIconNames(): IconName[] {
	return Object.values(IconName)
}

export function iconDefinition(name: IconName): IconDefinition | undefined {
	return definitions[name]
}
